/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/contratos/relatorios`

export default {
    obterFiltrosOpcoes(tipo) {
        return axiosJwt
            .get(`${api}/filtrosopcoes/${tipo}`)
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    emitirRelatorio(relatorio, filtros) {
        let filtrosString = '?'

        if (filtros.contrato) {
            filtrosString = `${filtrosString}contrato=${filtros.contrato}&`
        }

        if (filtros.processoCliente) {
            filtrosString = `${filtrosString}processoCliente=${filtros.processoCliente}&`
        }

        if (filtros.responsavel) {
            filtrosString = `${filtrosString}responsavel=${filtros.responsavel}&`
        }

        if (filtros.unidade) {
            filtrosString = `${filtrosString}unidade=${filtros.unidade}&`
        }

        if (filtros.fornecedor) {
            filtrosString = `${filtrosString}fornecedor=${filtros.fornecedor}&`
        }

        if (filtros.centroCusto) {
            filtrosString = `${filtrosString}centroCusto=${filtros.centroCusto}&`
        }

        if (filtros.processo) {
            filtrosString = `${filtrosString}processo=${filtros.processo}&`
        }

        if (filtros.documento) {
            filtrosString = `${filtrosString}documento=${filtros.documento}&`
        }

        if (filtros.comprometimento) {
            filtrosString = `${filtrosString}comprometimento=${filtros.comprometimento}&`
        }

        if (filtros.dataMovimentoDe) {
            filtrosString = `${filtrosString}dataMovimentoDe=${filtros.dataMovimentoDe}&`
        }

        if (filtros.dataMovimentoAte) {
            filtrosString = `${filtrosString}dataMovimentoAte=${filtros.dataMovimentoAte}&`
        }

        if (filtros.dataInicioDe) {
            filtrosString = `${filtrosString}dataInicioDe=${filtros.dataInicioDe}&`
        }

        if (filtros.dataInicioAte) {
            filtrosString = `${filtrosString}dataInicioAte=${filtros.dataInicioAte}&`
        }

        if (filtros.dataFimDe) {
            filtrosString = `${filtrosString}dataFimDe=${filtros.dataFimDe}&`
        }

        if (filtros.dataFimAte) {
            filtrosString = `${filtrosString}dataFimAte=${filtros.dataFimAte}&`
        }

        if (filtros.apenasAtivos) {
            filtrosString = `${filtrosString}apenasAtivos=${filtros.apenasAtivos}&`
        }

        return axiosJwt
            .get(`${api}/${relatorio}${filtrosString}`, {
                responseType: 'blob'
            })
            .then((response) => {
                if (response.status === 204) {
                    return {
                        noContent: true,
                        message:
                            'Não foram encontrados resultados para essa busca'
                    }
                }
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    construirQueryStringLAI(filtros = {}) {
        let queryString = '?'

        if (filtros.contratoId) {
            queryString = `${queryString}contratoId=${filtros.contratoId}&`
        }

        if (filtros.dataDe) {
            queryString = `${queryString}dataDe=${filtros.dataDe}&`
        }

        if (filtros.dataAte) {
            queryString = `${queryString}dataAte=${filtros.dataAte}&`
        }

        if (queryString === '?') {
            queryString = ''
        } else {
            queryString = queryString.slice(0, -1)
        }

        return queryString
    },

    obterRelatoriosLAI(filtros = {}) {
        const queryString = this.construirQueryStringLAI(filtros)

        return axiosJwt
            .get(`${api}/gestaojuridica/contratos-lai${queryString}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    emitirRelatorioLAI(filtros = {}, idsNaoSelecionados = []) {
        const queryString = this.construirQueryStringLAI(filtros)

        const body = {
            idsNaoSelecionados: idsNaoSelecionados
        }

        return axiosJwt
            .post(`${api}/gestaojuridica/relatorio-lai-xlsx${queryString}`, body, {
                responseType: 'blob'
            })
            .then((response) => {
                if (response.status === 204) {
                    return {
                        noContent: true,
                        message:
                            'Não foram encontrados resultados para essa busca'
                    }
                }
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    emitirRelatorioLAIPDF(filtros = {}, idsNaoSelecionados = []) {
        const queryString = this.construirQueryStringLAI(filtros)

        const body = {
            idsNaoSelecionados: idsNaoSelecionados
        }

        return axiosJwt
            .post(`${api}/gestaojuridica/relatorio-lai-pdf${queryString}`, body, {
                responseType: 'blob'
            })
            .then((response) => {
                if (response.status === 204) {
                    return {
                        noContent: true,
                        message:
                            'Não foram encontrados resultados para essa busca'
                    }
                }
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    excluirRelatorioLAI(id, justificativa) {
        return axiosJwt
            .delete(`${api}/gestaojuridica/excluir-relatorio-lai/${id}`, {
                data: {
                    Justificativa: justificativa || ''
                }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    editarRelatorioLAI(id, dadosComplementares) {
        return axiosJwt
            .put(
                `${api}/gestaojuridica/contrato-lai/${id}`,
                dadosComplementares
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    downloadPlanilhaRelatorioContratoLAI(id) {
        let url = `${api}/gestaojuridica/baixar-contrato-lai/${id}`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRelatoriosIj(cnpj) {
        return axiosJwt
            .get(`${api}/gestaojuridica/contratos-ij/${cnpj}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirRelatorioIj(id) {
        return axiosJwt
            .delete(`${api}/gestaojuridica/excluir-relatorio-ij/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadPlanilhaRelatorioIj(id) {
        let url = `${api}/gestaojuridica/baixar-contrato-ij/${id}`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

     obterRelatoriosOrcamento(cnpj) {
        return axiosJwt
            .get(`${api}/gestaojuridica/orcamento-resultado-itens/${cnpj}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirRelatorioOrcamento(id) {
        return axiosJwt
            .delete(`${api}/gestaojuridica/excluir-orcamento-resultado/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadPlanilhaRelatorioOrcamento(id) {
        let url = `${api}/gestaojuridica/baixar-orcamento-resultado/${id}`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
